import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { Container, RemainingContainer, Title, RemainingItem } from './styles';

const SideBar = ({remaining, bookingId}) => {  

  const history = useHistory()

  return (
    <Container>
      {
        remaining.length? (
          <>
            <RemainingContainer>
              <Title>Now Viewing</Title>
              { 
                remaining.filter(item=>item.bookingId===bookingId).map((item, index) => {
                  return (
                      <RemainingItem key={index}>
                        <div>Arrived {moment(item.checkinByCheckinId?.createAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}</div>
                        <div>{item.name}</div>
                      </RemainingItem>
                  )               
                })
              }
            </RemainingContainer>
            <RemainingContainer>
              <Title>Remaining ({remaining.length-1})</Title>
              {
                remaining.filter(item=>item.bookingId!==bookingId).map((item, index) =>  {
                  return (
                    <RemainingItem
                      key={index}
                      href={`https://pms.rookhotel.com/review-photos/${item.bookingId}`}
                      rel='noopener noreferrer'
                      onClick={(event)=>{
                        // Handle special key combinations (Ctrl/Cmd+click)
                        if (event.metaKey || event.ctrlKey) {
                          // Allow default behavior (opens in new tab)
                          return;
                        }
                        
                        // Prevent default anchor behavior (full page reload)
                        event.preventDefault();
                        
                        // Perform client-side navigation
                        history.push(`/review-photos/${item.bookingId}`)
                      }}
                    >
                      <div>Arrived 21/6/2020 @ 5:13 PM</div>
                      <div>{item.name}</div>
                    </RemainingItem>
                  )
                })
              }
            </RemainingContainer>
          </>
        ): (
          <>
            <RemainingContainer>
              <Title>Now Viewing</Title>
              <RemainingItem>
                <div>Arrived 21/6/2020 @ 5:13 PM</div>
                <div>Jane Doe</div>
              </RemainingItem>
            </RemainingContainer>
            <RemainingContainer>
              <Title>Remaining (4)</Title>
              <RemainingItem>
                <div>Arrived 21/6/2020 @ 5:13 PM</div>
                <div>Jane Doe</div>
              </RemainingItem>
              <RemainingItem>
                <div>Arrived 21/6/2020 @ 5:13 PM</div>
                <div>Jane Doe</div>
              </RemainingItem>
              <RemainingItem>
                <div>Arrived 21/6/2020 @ 5:13 PM</div>
                <div>Jane Doe</div>
              </RemainingItem>
              <RemainingItem>
                <div>Arrived 21/6/2020 @ 5:13 PM</div>
                <div>Jane Doe</div>
              </RemainingItem>
            </RemainingContainer>
          </>
        )
      }
    </Container>
  )
}

export default SideBar;
